export const fmtMs = (ms, precise = true) => {
  const total = Math.floor(ms / 1000), frac = String(ms % 1000).padStart(3, "0");
  const h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
  const base = h ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}` : `${m}:${String(s).padStart(2, "0")}`;
  return precise ? `${base}.${frac}` : base;
};
// de-duplicated whole-second timecodes, the format the ad-mention fields use
export const plainCodes = (hits) => [...new Set(hits.map((h) => fmtMs(h.start, false)))].join(", ");
